import EventCollagesOption from './EventCollagesOption';

export default EventCollagesOption;
